import { AppAPI, } from '@moderepo/mode-apis';
/**
 * The types of action that can be dispatched to update this sub state.
 */
export var DeviceConfigSchemasActionType;
(function (DeviceConfigSchemasActionType) {
    DeviceConfigSchemasActionType["SET_DEVICE_CONFIG_SCHEMAS"] = "set device config schemas";
    DeviceConfigSchemasActionType["CLEAR_DEVICE_CONFIG_SCHEMAS"] = "clear device config schemas";
})(DeviceConfigSchemasActionType || (DeviceConfigSchemasActionType = {}));
export const setDeviceConfigSchemas = (deviceId, schemas) => {
    return {
        type: DeviceConfigSchemasActionType.SET_DEVICE_CONFIG_SCHEMAS,
        deviceId,
        schemas,
    };
};
export const clearDeviceConfigSchemas = (deviceId) => {
    return {
        type: DeviceConfigSchemasActionType.CLEAR_DEVICE_CONFIG_SCHEMAS,
        deviceId,
    };
};
/**
 * Get all config schemas belonged to a device
 * @param deviceId - The id of the device to look for
 */
export const fetchDeviceConfigSchemas = (deviceId) => {
    return async (dataDispatch) => {
        const schemas = await AppAPI.getInstance().getDeviceConfigurationSchemas(deviceId);
        await dataDispatch(setDeviceConfigSchemas(deviceId, schemas));
    };
};
